export const vehiculesColumns = [
    { title: "Véhicule", field: "vehicule", minWidth: 100 },
    { title: "Description", field: "description", minWidth: 250 },
    { title: "Catégorie", field: "categorie", minWidth: 250 },
    { title: "Garage", field: "garage", cell: "garageCell", minWidth: 75 },
    { title: "Année", field: "annee", minWidth: 75 },
    { title: "Numéro de série", field: "numeroSerie", minWidth: 200 },
    { title: "NIR", field: "nir", minWidth: 100 },
    { title: "NEQ", field: "neq", minWidth: 100 },
];